import { useEffect, useState, type FormEvent } from 'react';
import { useAuthProviders, useLogin } from '../features/hooks.js';
import { LogoMark } from '../components/Logo.js';
import { InlineError } from '../components/ui.js';

export function Login() {
  const login = useLogin();
  const providers = useAuthProviders();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [ssoError, setSsoError] = useState('');

  // surface an SSO error passed back as ?authError=…
  useEffect(() => {
    const err = new URLSearchParams(window.location.search).get('authError');
    if (err) {
      setSsoError(err);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate({ email, password });
  };

  const hasSso = providers.data?.google || providers.data?.microsoft;

  return (
    <div className="signin">
      <div className="modal login-card">
        <div className="modal-hd" style={{ gap: 12 }}>
          <LogoMark size={34} glow />
          <div>
            <h3 style={{ letterSpacing: '0.14em' }}>Rolodex</h3>
            <div className="muted signin-sub">
              Technohull · Assembly
            </div>
          </div>
        </div>
        <div className="modal-bd">
          {ssoError && <InlineError error={new Error(ssoError)} onDismiss={() => setSsoError('')} />}

          {providers.data?.google && (
            <a className="btn" style={{ width: '100%', justifyContent: 'center', marginBottom: 8 }} href="/api/auth/google/start">
              Sign in with Google
            </a>
          )}
          {providers.data?.microsoft && (
            <a className="btn" style={{ width: '100%', justifyContent: 'center', marginBottom: 8 }} href="/api/auth/microsoft/start">
              Sign in with Microsoft - NOT AVAILABLE YET
            </a>
          )}

          {hasSso && !showPassword && (
            <button className="btn btn-ghost" style={{ width: '100%', marginTop: 4, justifyContent: 'center' }} onClick={() => setShowPassword(true)}>
              Sign in with a password instead
            </button>
          )}

          {(!hasSso || showPassword) && (
            <form onSubmit={submit} style={{ marginTop: hasSso ? 12 : 0 }}>
              {hasSso && <div className="muted signin-or">- or -</div>}
              <label className="field-label" htmlFor="login-email">Email</label>
              <input id="login-email" className="field" style={{ width: '100%' }} type="email" inputMode="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
              <label className="field-label" htmlFor="login-password" style={{ marginTop: 10 }}>Password</label>
              <input id="login-password" className="field" style={{ width: '100%' }} type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
              {login.isError && <InlineError error={login.error} onDismiss={() => login.reset()} />}
              <button className="btn btn-primary" style={{ width: '100%', marginTop: 12, justifyContent: 'center' }} type="submit" disabled={login.isPending || !email || !password}>
                {login.isPending ? 'Signing in…' : 'Sign in'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
